import pages from './pages';
import routes from './routes';

const en = {
  ...pages,
  routes,
};

export default en;
